<template>
	<ValidationForm #default="{ handleSubmit }">
		<Modal width="640px">
			<template #modal-title>
				Request Site Scan
			</template>
			<template #modal-content>
				<p class="subtitle-2">
					Please confirm the key details for this scan. All fields are required.
				</p>
				<v-row>
					<v-col
						cols="12"
					>
						<TextField
							:value="siteScan.scanName"
							label="Scan Name *"
							:disabled="!siteScannerFullAccess"
							:rules="{ required: true, max: 255 }"
							explainer="Enter a descriptive name for this scan."
							@input="updateScanRequest('scanName', $event)"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col
						v-if="clientMultiBranded && !singleBrand"
						cols="12"
					>
						<Dropdown
							:value="siteScan.brandId"
							label="Brand *"
							:disabled="!siteScannerFullAccess"
							:items="brandOptions"
							rules="required"
							explainer="Select the brand this scan will be associated with."
							searchable
							custom-sort
							@input="updateScanRequest('brandId', $event)"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col
						cols="12"
					>
						<TextField
							:value="siteScan.emailAddress"
							label="Email Address *"
							:disabled="!siteScannerFullAccess"
							:rules="{ required: true, email: true }"
							explainer="Syrenis will use this Email Address to send a notification once scan results are ready."
							@input="updateScanRequest('emailAddress', $event)"
						/>
					</v-col>
				</v-row>
			</template>
			<template #modal-footer>
				<SecondaryActionButton @click="$emit('cancel')">
					Cancel
				</SecondaryActionButton>
				<v-spacer />
				<PrimaryActionButton
					:disabled="!siteScannerFullAccess"
					@click="handleSubmit(confirm)"
				>
					Confirm & Request Scan
				</PrimaryActionButton>
			</template>
		</Modal>
	</ValidationForm>
</template>
<script>
// ValidationProvider removed; using ValidationForm + Vuetify rules instead
import Modal from '../../../../../../shared/components/modal.vue'
import TextField from '../../../../../../shared/components/text-field.vue'
import Dropdown from '../../../../../../shared/components/dropdown.vue'
import PrimaryActionButton from '../../../../../../shared/components/primary-action-button.vue'
import SecondaryActionButton from '../../../../../../shared/components/secondary-action-button.vue'
import ValidationForm from '../../../../../../shared/components/validation-form.vue'
export default {
	name: 'scan-request-confirm-modal',
	components: { Modal, TextField, Dropdown, PrimaryActionButton, SecondaryActionButton, ValidationForm },
	props: {
		value: { type: Boolean, default: false },
		siteScan: { type: Object, required: true },
		updateScanRequest: { type: Function, required: true },
		brandOptions: { type: Array, default: () => [] },
		siteScannerFullAccess: { type: Boolean, default: false },
		clientMultiBranded: { type: Boolean, default: true },
		singleBrand: { type: Boolean, default: false }
	},
	emits: ['input', 'confirm', 'cancel'],
	methods: {
		confirm () {
			this.$emit('confirm')
		}
	}
}
</script>
